import { Navigate } from "react-router-dom";
import { auth } from "../firebase/firebase";
import { useAuth } from "../contexts/AuthContext";

const LinguistProtectedRoute = ({ children }) => {
  const { currentUser, linguistUserLoggedIn } = useAuth();

  // Linguist session confirmed by the AuthContext bootstrap.
  if (linguistUserLoggedIn) {
    return children;
  }

  // Fresh-login transition: LinguistLogin navigates here right after Firebase
  // sign-in, but the AuthContext /me bootstrap may not have resolved yet.
  // `currentUser` is still null, or is a raw Firebase user without a Role
  // when the server was briefly unreachable — keep the shell mounted and let
  // the bootstrap settle instead of flash-redirecting back to login.
  if (auth.currentUser && !currentUser?.Role) {
    return children;
  }

  // Confirmed non-linguist session (a hydrated Admin/Member Role) or no
  // session at all: bounce to the linguist login. LinguistLogin re-checks
  // /me for existing sessions, so this cannot loop for real linguists.
  return <Navigate to="/linguist-login" replace />;
};

export default LinguistProtectedRoute;
